import React, { FC, useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import styled from 'styled-components';

interface ProgressProps {
  step: number;
  questionsLength: number;
  onBackClick: () => void;
}

const ProgressBarContainer = styled.div`
  height: 0.25rem;
  background-color: ${({ theme }) => theme.colors.light60};
  border-radius: 50px;
`;

const ProgressBar = styled.div<{ value: number }>`
  width: ${({ value }) => value}%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.green};
  border-radius: 50px;
  transition: width 0.25s;
`;

const Progress: FC<ProgressProps> = ({
  step,
  questionsLength,
  onBackClick,
  ...props
}) => {
  const [value, setValue] = useState<number>(0);

  const location = useLocation();

  // useEffect(() => {
  //   calculateValue();
  // }, [location, questionsLength]);

  // const calculateValue = () => {
  //   if (!questionsLength) {
  //     return;
  //   }

  //   const question = new URLSearchParams(location.search).get('q');
  //   if (!question || Number(question) === 1) {
  //     return setValue(5);
  //   }

  //   const firstThird = Math.round(questionsLength / 3);
  //   const secondThird = Math.round((questionsLength / 3) * 2);
  //   const partValue = 100 / questionsLength;
  //   const multiplier = 0.7;

  //   const values = new Array(questionsLength).fill(null).map((_, index) => {
  //     const i = index + 1;

  //     if (i <= firstThird) {
  //       return partValue * (multiplier + 1);
  //     }
  //     if (i > firstThird && i <= secondThird) {
  //       return partValue;
  //     }
  //     return partValue - partValue * multiplier;
  //   });

  //   const calculatedValue = values
  //     .slice(0, Number(question))
  //     .reduce((total, value) => total + value);

  //   if (calculatedValue >= 99) {
  //     return setValue(99);
  //   }

  //   setValue(calculatedValue);
  // };

  const progressedPercentages = (100 * step) / questionsLength;

  return (
    <div {...props}>
      <ProgressBarContainer>
        <ProgressBar value={progressedPercentages} />
      </ProgressBarContainer>
    </div>
  );
};

export default Progress;
